<template>
  <div class="contrast-data">
    <div class="model-type-box">
      <div class="model-type">
        <el-radio-group v-model="model_type" style="margin-bottom: 20px;" @change="tabClick">
          <el-radio-button :label="1">班级对比</el-radio-button>
          <el-radio-button :label="2">小组对比</el-radio-button>
          <el-radio-button :label="3">个人对比</el-radio-button>
        </el-radio-group>
        <div class="btns">
          <!-- <el-button type="primary" class="fr tea-btn" @click="model_type=4" v-show="model_type==3">历史小组成绩</el-button> -->
          <!-- <el-button type="primary" class="fr tea-btn" @click="screenShow()" v-show="model_type==3">分屏显示</el-button> -->
        </div>
      </div>
    </div>
    <!-- 对比数据的box -->
    <div class="data-model">
      <classContrast v-if="model_type==1" />
      <groupContrast v-if="model_type==2" />
      <stuContrast v-if="model_type==3" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    classContrast: (resolve) => {
      require(["@/components/teacher/dataCenter/classContrast.vue"], resolve);
    },
    groupContrast: (resolve) => {
      require(["@/components/teacher/dataCenter/groupContrast.vue"], resolve);
    },
    stuContrast: (resolve) => {
      require(["@/components/teacher/dataCenter/stuContrast.vue"], resolve);
    },
  },
  data() {
    return {
      model_type: 1,
    }
  },
  methods: {
    // 带年纪tab栏
    tabClick() { },
  },
}
</script>
<style lang="scss" scoped>
.contrast-data {
  height: 100%;
}
.model-type-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tea-search {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}
.model-type {
  // width: 100%;
  display: flex;
  justify-content: space-between;
  .tea-btn {
    margin-bottom: 20px;
    &.el-button--primary {
      background-color: #5186c2;
      border-color: #5186c2;
    }
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #5186c2 !important;
    border: 1px solid #5186c2;
  }
  ::v-deep .el-radio-button__inner {
    font-size: 16px;
  }
}
.data-model {
  height: calc(100% - 50px);
}
</style>


